import React from 'react';
import { physicsCalculators_Fr } from '../ConstantsPhysicsCalculator';
import SharedHelmet from '.././Helmet';

const TITLE = 'Calculatrices de physique gratuites en ligne';
const DESCRIPTION = 'Accedez a des calculatrices de physique en francais pour la vitesse, force, energie, pression, electricite, resistance et bien d autres formules utiles.';
const KEYWORDS = 'calculatrice physique, calcul vitesse, calcul force, energie cinetique, loi ohm, resistance electrique, pression';
const OG_URL = 'https://do-calculate.com/fr/physics-calculators/';

function PhysicsCalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div>
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-info" role="alert">
                    <p>Retrouvez ici des outils de physique clairs pour les etudiants, enseignants et profils techniques.</p>
                </div>
            </div>
            <hr />
            <table>
                <thead>
                    <tr>
                        <th>Calculatrice</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {physicsCalculators_Fr.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}

export default PhysicsCalculatorsList;
